/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

const accordions = document.querySelectorAll(".product-meta_accordion");
if (accordions.length > 0) {
  accordions[0].classList.add("first-accordion");
  accordions[accordions.length - 1].classList.add("last-accordion");
}

$(document).ready(function() {

    $(".testimonial-secondary-blocks").slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".mega-menu-sec-carousel").slick({
      arrows: true,
      dots: false,
      prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right" id="icon"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l14 0"></path><path d="M13 18l6 -6"></path><path d="M13 6l6 6"></path></svg></button>`,
      nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right" id="icon"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l14 0"></path><path d="M13 18l6 -6"></path><path d="M13 6l6 6"></path></svg></button>`,
      infinite: false,
      slidesToShow: 8,
      slidesToScroll: 4,
      responsive: [
      {
        breakpoint: 1200,
        settings: "unslick"
      }
    ]
  });

  $("body").on("click", ".product-meta-share-button", function (){
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').attr('open', '');
  })
  $("body").on("click", ".product-meta-share-button-close, .product-meta-share-overlay", function (){
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').removeAttr('open', '');
  })

  $("body").on("click", ".product-meta_best_buy-copy_code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute
    if (!text) return; // prevent copying empty
    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });
  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute

    if (!text) return; // prevent copying empty

    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });

  $('.product-meta_accordion-item_title').click(function() {
    $(this).toggleClass('active');
    $(this).next('.product-meta_accordion-item_content').slideToggle();
  
    // Toggle aria-expanded attribute
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });

  $("body").on("click", ".parent-mobile-nav__link, .sibling-mobile-nav__link", function () {
    const activeDropdown = $(this);
    const isParent = activeDropdown.hasClass("parent-mobile-nav__link");

    // Determine the correct collapsible target based on type
    const currentDropdown = isParent
      ? activeDropdown.next(".mobile-nav_collapsible")
      : activeDropdown.next(".sibling-mobile-nav_collapsible");

    const linkSelector = isParent ? ".parent-mobile-nav__link" : ".sibling-mobile-nav__link";
    const collapseSelector = isParent ? ".mobile-nav_collapsible" : ".sibling-mobile-nav_collapsible";

    // Close all other dropdowns of the same type
    $(linkSelector).not(activeDropdown).attr("aria-expanded", "false");
    $(collapseSelector).not(currentDropdown).removeAttr("open");

    // Toggle current link
    const isExpanded = activeDropdown.attr("aria-expanded") === "true";
    activeDropdown.attr("aria-expanded", !isExpanded);

    // Toggle current dropdown
    if (isExpanded) {
      currentDropdown.removeAttr("open");
    } else {
      currentDropdown.attr("open", "");
    }
  });

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

});

// function addFreeProduct(event, cart) { 
//   const settings = window.themeVariables?.settings;
//   if (!settings) return;
//   const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
//   const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
//   const existingGift = cart.items.find(i => i.variant_id === freeProductId1);
//   console.log('existingGift',existingGift);
//   console.log(milestone1,'milestone1');
//   const total = cart.total_price;
//   var line1 = -1;
//   line1 = cart.items.findIndex(item => item.variant_id === freeProductId1);
//   console.log('line1---',line1)
//   var line_key_1 = cart.items[line1];
//   var items = [];
//   if ((total > milestone1 && line1 === -1) && freeProductId1) {
//     items.push({
//       quantity: 1,
//       id: freeProductId1,
//       properties: {
//         '_type': 'free_gift',
//       }
//     })
//   }
//   if(items.length > 0){
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: {items},
//       dataType: 'json',
//       error: function(jqXHR, textStatus, errorThrown){
//         var response = $.parseJSON(jqXHR.responseText);
//         console.log('Free Gift Error',response.description);
//       },
//       success: function() {
//         console.log('success');
//         refreshCart()
//       }
//     });
//   }
//   var updateData = {};
//   console.log('line_key_1',line_key_1);
//   if (total <= milestone1 && line1 !== -1) {
//     updateData[line_key_1.key] = 0;    
//   }
//   if (Object.keys(updateData).length > 0) {
//      $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       data: {
//         updates: updateData
//       },
//       dataType: 'json',
//       success: function(data) {                
//         console.log('sucess');
//         refreshCart()
//       },
//       error: function (jqXHR, textStatus, errorThrown) {
//         console.log(jqXHR);
//       }
//     });
//   }
//   function refreshCart() {
//     if (document.body.classList.contains("template-cart")) {
//       location.reload();
//     }else{  
//       $.getJSON("/cart.js", function (cart) {
//         document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//           bubbles: true,
//           detail: { cart }
//         })); 
//       });
//     }
//   }
// }

// function addFreeProduct(event, cart) {
//   const settings = window.themeVariables?.settings;
//   if (!settings) return;
//   const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
//   const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
//   const existingGift = cart.items.find(i => i.variant_id === freeProductId1);
//   const total = cart.total_price;
//   var items = [];
//   if (total > milestone1) {
//     if (!existingGift) {
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//           items: [{
//             id: freeProductId1,
//             quantity: 1,
//             properties: { '_type': 'free_gift' }
//           }]
//         },
//         dataType: 'json',
//         success: function() {
//           console.log('Free gift added');
//           refreshCart();
//         },
//         error: function(err) {
//           console.log('Error adding free gift', err);
//         }
//       });
//     }
//   }
//   else{
//     if (existingGift) {
//       $.ajax({
//         type: 'POST',
//         url: '/cart/change.js',
//         data: {
//           id: existingGift.key,
//           quantity: 0
//         },
//         dataType: 'json',
//         success: function() {
//           console.log('Free gift removed');
//           refreshCart();
//         },
//         error: function(err) {
//           console.log('Error removing free gift', err);
//         }
//       });
//     }
//   }
//   function refreshCart() { 
//       $.getJSON("/cart.js", function (cart) {
//         document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//           bubbles: true,
//           detail: { cart }
//         })); 
//       });
//   }
// }

function addFreeProduct(event, cart) {
  const settings = window.themeVariables?.settings;
  if (!settings) return;
  const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
  const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
  const existingGift = cart.items.find(i => i.variant_id === freeProductId1);
  const total = cart.total_price;
  var items = [];
  if (total > milestone1) {
    if (!existingGift) {
      items.push({
        quantity: 1,
        id: freeProductId1
      });
      var data = {items};
      console.log('data',data)
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(data) {   
        console.log("Free gift added");   
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }.bind(this));  
    }
  }
  else{
    if (existingGift) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: existingGift.key,
          quantity: 0
        },
        dataType: 'json',
        success: function() {
          console.log('Free gift removed');
          refreshCart();
        },
        error: function(err) {
          console.log('Error removing free gift', err);
        }
      });
    }
  }
  function refreshCart() { 
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
  }
}

document.addEventListener('cart:refresh', function(event) {
  console.log('event',event);
  var cart = event.detail.cart; // Get the updated content of the cart
  addFreeProduct(event,cart);
});

